import apiClient from '../apiClient';
import { DELETE_PLACE_URL } from '../apiUrl';

const deletePlaceApi = Id => {
  return apiClient.delete(DELETE_PLACE_URL(Id));
};

export default deletePlaceApi;
